import React from 'react';
import { useRouteError } from 'react-router-dom';

const ErrorBoundary = () => {
  const error = useRouteError();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <h1 className="text-2xl font-bold text-red-600 mb-4">Oops! Bir Hata Oluştu</h1>
        <p className="text-gray-600 mb-4">
          {error.status === 404 
            ? 'Aradığınız sayfa bulunamadı.'
            : 'Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.'}
        </p>
        <div className="text-sm text-gray-500">
          <p>Hata Kodu: {error.status || 'Bilinmiyor'}</p>
          <p>Hata Mesajı: {error.message || 'Bilinmiyor'}</p>
        </div>
        <button 
          onClick={() => window.location.href = '/'}
          className="mt-6 w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition-colors"
        >
          Ana Sayfaya Dön
        </button>
      </div>
    </div>
  );
};

export default ErrorBoundary; 